import { useEffect, RefObject, useRef } from 'react'

type CompareFn<T> = (a: T, b: T) => boolean

export function useScrollToTopOnValueChange<T>(
  value: T,
  ref: RefObject<HTMLElement>,
  compareFn: CompareFn<T> = (a, b) => a === b
) {
  const previousValueRef = useRef<T>(value)

  useEffect(() => {
    if (!compareFn(value, previousValueRef.current)) {
      if (ref.current) {
        ref.current.scrollTop = 0
      }
      previousValueRef.current = value
    }
  }, [value, ref, compareFn])
}
